import { XSDActions } from './XSDActions'

/** Описание элементов в OWL 
 * description содержит информацию о графах. Для элементов графа фиксируется триплет
*/

const initialXSDState = {
    state: "empty",
    content: undefined,
}
export const xsd = (state = { ...initialXSDState} , action) => {
  switch (action.type) {
    case "XSDActions.EMPTY":
      return{
        ...initialXSDState,
      };
    case "XSDActions.LOAD_STARTED":
      return{
        ...state,
        state: "load",
    };
    case "XSDActions.LOAD_ERROR":
      return {
        ...initialXSDState,
        error: action.error,
        state: "error",
    };
    case "XSDActions.XSD":
      return {
        ...state,
        content: action.content,
        state: "loaded",
    };
    default:
      return state;
  }
}
